// src/sections/Sushis/Sushis.js
import React from 'react';
import styles from './Sushis.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as solidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as regularHeart } from '@fortawesome/free-regular-svg-icons';

// CORRIGÉ : Descriptions retirées pour correspondre exactement au menu.
const sushisData = [
  {
    id: "sushi-p1",
    name: "P1 : 8 Sushis",
    price: "13.00€",
    description: ""
  },
  {
    id: "sushi-p2",
    name: "P2 : 12 Makis",
    price: "13.00€",
    description: ""
  },
  {
    id: "sushi-p3",
    name: "P3 : 4 Sushis - 6 Makis",
    price: "13.00€",
    description: ""
  },
  {
    id: "sushi-p4-a",
    name: "P4 : 6 California Rolls - 4 Sushis",
    price: "13.50€",
    description: ""
  },
  {
    id: "sushi-p4-b",
    name: "P5 : 6 California Rolls - 4 Sushis",
    price: "14.00€",
    description: ""
  },
];

const Sushis = ({ id, favorites, addFavorite, removeFavorite }) => {

  const isFavorite = (item) => {
    return favorites.some(favItem => favItem.id === item.id);
  };

  const handleFavoriteClick = (item) => {
    if (isFavorite(item)) {
      removeFavorite(item.id);
    } else {
      addFavorite(item);
    }
  };

  return (
    <section id={id} className={styles.sushis}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>SUSHIS</h2>
        <p className={styles.subtitle}>SUR COMMANDE</p>

        <div className={styles.menuList}>
          {sushisData.map((item) => (
            <div key={item.id} className={styles.menuItem}>
              <span className={styles.itemName}>{item.name}</span>
              <span className={styles.itemSeparator}></span>
              
              <div className={styles.priceAndFavorite}>
                <span className={styles.itemPrice}>{item.price}</span>
                <button
                  className={`${styles.favoriteButton} ${isFavorite(item) ? styles.isFavorite : ''}`}
                  onClick={() => handleFavoriteClick(item)}
                  aria-label={isFavorite(item) ? `Retirer ${item.name} des favoris` : `Ajouter ${item.name} aux favoris`}
                >
                  <FontAwesomeIcon icon={isFavorite(item) ? solidHeart : regularHeart} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Sushis;